import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonFunctions } from 'src/app/shared/common-functions';
declare var dataLayer;
@Component({
  selector: 'app-recent-activty-order-dialog',
  templateUrl: './recent-activty-order-dialog.component.html',
  styleUrls: ['./recent-activty-order-dialog.component.scss']
})
export class RecentActivtyOrderDialogComponent{
  userType: string;
  userId: any;
  tierType: any;
  constructor(public dialogRef: MatDialogRef<RecentActivtyOrderDialogComponent>,
    private commonFunction: CommonFunctions)
   {
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
   }
  closeSheet(){
    this.dialogRef.close();
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}
